import React from 'react';
import { motion } from 'framer-motion';
import { FaCertificate, FaFileAlt, FaMoneyBillWave, FaHome, FaWater, FaLightbulb, FaRoad, FaTree } from 'react-icons/fa';
import { translations } from '../i18n';
function Services({ language }) {
  const t = translations[language];

  const services = [
    { icon: <FaCertificate />, title: 'जन्म प्रमाणपत्र', desc: 'जन्म नोंदणी आणि प्रमाणपत्र जारी करणे', time: '7 दिवस' },
    { icon: <FaFileAlt />, title: 'मृत्यू प्रमाणपत्र', desc: 'मृत्यू नोंदणी आणि प्रमाणपत्र जारी करणे', time: '7 दिवस' },
    { icon: <FaMoneyBillWave />, title: 'उत्पन्न प्रमाणपत्र', desc: 'उत्पन्न प्रमाणपत्र जारी करणे', time: '15 दिवस' },
    { icon: <FaHome />, title: 'अधिवास प्रमाणपत्र', desc: 'अधिवास प्रमाणपत्र जारी करणे', time: '15 दिवस' },
    { icon: <FaWater />, title: 'पाणी पुरवठा', desc: 'पिण्याच्या पाण्याची सुविधा', time: '24/7' },
    { icon: <FaLightbulb />, title: 'विद्युत सुविधा', desc: 'विद्युत कनेक्शन आणि देखभाल', time: '24/7' },
    { icon: <FaRoad />, title: 'रस्ते दुरुस्ती', desc: 'गावातील रस्त्यांची देखभाल', time: 'नियमित' },
    { icon: <FaTree />, title: 'वृक्षारोपण', desc: 'पर्यावरण संवर्धन कार्यक्रम', time: 'वार्षिक' },
  ];

  return (
    <div style={{ marginTop: '80px' }}>
      <motion.section 
        className="hero" 
        style={{ height: '50vh' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="hero-content">
          <h1 className="page-hero-title">{t.ourServices}</h1>
          <p className="page-hero-sub">नागरिकांसाठी उपलब्ध सर्व सेवा</p>
        </div>
      </motion.section>

      <section className="services-section">
        <h2 className="section-title">आमच्या सेवा</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
              <p style={{ color: '#ff6b35', fontWeight: 'bold', marginTop: '0.5rem' }}>
                कालावधी: {service.time}
              </p>
              <button className="cta-button" style={{ marginTop: '1rem', padding: '0.5rem 1.5rem', fontSize: '0.9rem' }}>
                अर्ज करा
              </button>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="about-section">
        <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: '2rem', color: '#004e89', marginBottom: '2rem' }}>
            ऑनलाइन सेवा कशा मिळवाव्यात?
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem' }}>
            <motion.div 
              className="stat-card"
              whileHover={{ scale: 1.05 }}
            >
              <div className="stat-number">1</div>
              <h3>नोंदणी करा</h3>
              <p>वेबसाइटवर नोंदणी करा</p>
            </motion.div>
            <motion.div 
              className="stat-card"
              whileHover={{ scale: 1.05 }}
            >
              <div className="stat-number">2</div>
              <h3>अर्ज भरा</h3>
              <p>आवश्यक कागदपत्रे अपलोड करा</p>
            </motion.div>
            <motion.div 
              className="stat-card"
              whileHover={{ scale: 1.05 }}
            >
              <div className="stat-number">3</div>
              <h3>शुल्क भरा</h3>
              <p>ऑनलाइन शुल्क भरा</p>
            </motion.div>
            <motion.div 
              className="stat-card"
              whileHover={{ scale: 1.05 }}
            >
              <div className="stat-number">4</div>
              <h3>प्रमाणपत्र मिळवा</h3>
              <p>डाउनलोड करा किंवा पोस्टाने मिळवा</p>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
